import Vue from 'vue';
import compositionRenderer from './plugin';
import { CREATOR_BASE_URL } from '../../../utils/configure-environment';

Vue.use(compositionRenderer, { creatorBaseUrl: CREATOR_BASE_URL });
